import React, { useEffect, useMemo, useState } from "react";
import { performance } from "../../data";
import Answer from "./Answer";

const ReadOnlyPerformance = ({ data, sectionRefs }) => {
  const sections = performance.sections;
  const sectionData = performance.sectionData;

  return (
    <div className="col-md-9">
      <div>
        {/* BEGIN: TRAINING & ENABLEMENT */}
        <section id={sections[0]} ref={sectionRefs?.[sections[0]]}>
          <div className="card rounded-lg">
            <h2 className="heading">{sections[0]}</h2>
            <p>
              <span className="d-block">
                {sectionData[sections[0]].description}
              </span>
            </p>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label htmlFor="certifications" className="question">
                  {sectionData[sections[0]].questions[0]}
                </label>
                <Answer>
                  <div id="certifications" className="d-flex flex-column gap-4">
                    {/* Associate Certifications */}
                    <div className="performance-cert-category">
                      <label
                        htmlFor="associate-certifications"
                        className="text-black-50"
                      >
                        Associate
                      </label>
                      <div>
                        <div className="performance-item-wrapper">
                          {data.certifications.associate.answer.map(
                            (item, index) => (
                              <span
                                className="performance-item"
                                key={`associate-${index}`}
                              >
                                {item}
                              </span>
                            ),
                          )}
                        </div>
                      </div>
                    </div>
                    {/* Administrator Certifications */}
                    <div className="performance-cert-category">
                      <label
                        htmlFor="associate-certifications"
                        className="text-black-50"
                      >
                        Administrator
                      </label>
                      <div className="performance-item-wrapper">
                        {" "}
                        {data.certifications.administrator.answer.map(
                          (item, index) => (
                            <span
                              className="performance-item"
                              key={`administrator-${index}`}
                            >
                              {item}
                            </span>
                          ),
                        )}
                      </div>
                    </div>
                    {/* Architect Certifications */}
                    <div className="performance-cert-category">
                      <label
                        htmlFor="associate-certifications"
                        className="text-black-50"
                      >
                        Architect
                      </label>
                      <div className="performance-item-wrapper">
                        {data.certifications.architect.answer.map(
                          (item, index) => (
                            <span
                              className="performance-item"
                              key={`architect-${index}`}
                            >
                              {item}
                            </span>
                          ),
                        )}
                      </div>
                    </div>
                    {/* Consultant Certifications */}
                    <div className="performance-cert-category">
                      <label
                        htmlFor="associate-certifications"
                        className="text-black-50"
                      >
                        Associate
                      </label>
                      <div className="performance-item-wrapper">
                        {data.certifications.consultant.answer.map(
                          (item, index) => (
                            <span
                              className="performance-item"
                              key={`consultant-${index}`}
                            >
                              {item}
                            </span>
                          ),
                        )}
                      </div>
                    </div>
                    {/* Developer Certifications */}
                    <div className="performance-cert-category">
                      <label
                        htmlFor="associate-certifications"
                        className="text-black-50"
                      >
                        Developer
                      </label>
                      <div className="performance-item-wrapper">
                        {data.certifications.developer.answer.map(
                          (item, index) => (
                            <span
                              className="performance-item"
                              key={`developer-${index}`}
                            >
                              {item}
                            </span>
                          ),
                        )}
                      </div>
                    </div>{" "}
                    {/* Cloud Certifications */}
                    <div className="performance-cert-category">
                      <label className="text-black-50">Cloud</label>
                      <div className="performance-item-wrapper">
                        {data.certifications.cloud?.answer?.map(
                          (item, index) => (
                            <span
                              className="performance-item"
                              key={`cloud-${index}`}
                            >
                              {item}
                            </span>
                          ),
                        )}
                      </div>
                    </div>
                  </div>
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="otherCertifications">
                  {sectionData[sections[0]].questions[1]}
                </label>
                <Answer>{data.otherCertifications.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label htmlFor="exercisesCompleted" className="question">
                  {sectionData[sections[0]].questions[2]}
                </label>
                <Answer>
                  <div className="performance-item-wrapper">
                    {data.exercisesCompleted.answer.map((item, index) => (
                      <span
                        className="performance-item"
                        key={`exercisesCompleted-${index}`}
                      >
                        {item}
                      </span>
                    ))}
                  </div>
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="mockInterviewsGiven">
                  {sectionData[sections[0]].questions[3]}
                </label>
                <Answer>{data.mockInterviewsGiven.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="mockInterviewDetails">
                  {sectionData[sections[0]].questions[4]}
                </label>
                <Answer>{data.mockInterviewDetails.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label
                  className="question"
                  htmlFor="expertLedSessionsPresented"
                >
                  {sectionData[sections[0]].questions[5]}
                </label>
                <Answer>{data.expertLedSessionsPresented.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="coffeeNLearnSessions">
                  {sectionData[sections[0]].questions[6]}
                </label>
                <Answer>{data.coffeeNLearnSessions.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="isMuleSoftMeetupSpeaker">
                  {sectionData[sections[0]].questions[7]}
                </label>
                <Answer>
                  {data.isMuleSoftMeetupSpeaker.answer ? "Yes" : "No"}
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="meetupDetails">
                  {sectionData[sections[0]].questions[8]}
                </label>
                <Answer>{data.meetupDetails.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="eventDetails">
                  {sectionData[sections[0]].questions[9]}
                </label>
                <Answer>{data.eventDetails.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="isMuleSoftMeetupLeader">
                  {sectionData[sections[0]].questions[10]}
                </label>
                <Answer>
                  {data.isMuleSoftMeetupLeader.answer ? "Yes" : "No"}
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15 ">
              <div className="input-group">
                <label className="question" htmlFor="isMuleSoftMentor">
                  {sectionData[sections[0]].questions[11]}
                </label>
                <Answer>{data.isMuleSoftMentor.answer ? "Yes" : "No"}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15 ">
              <div className="input-group">
                <label className="question" htmlFor="isMuleSoftAmbassador">
                  {sectionData[sections[0]].questions[12]}
                </label>
                <Answer>
                  {data.isMuleSoftAmbassador.answer ? "Yes" : "No"}
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15 ">
              <div className="input-group">
                <label
                  className="question"
                  htmlFor="salesforceSessionsPresented"
                >
                  {sectionData[sections[0]].questions[13]}
                </label>
                <Answer>{data.salesforceSessionsPresented.answer}</Answer>
              </div>
            </div>

            {/* <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label
                  className="question"
                  htmlFor="completedCaeliusAIEnablementProgram"
                >
                  {sectionData[sections[0]].questions[14]}
                </label>
                <Answer>
                  {data.completedCaeliusAIEnablementProgram.answer
                    ? "Yes"
                    : "No"}
                </Answer>
              </div>
            </div> */}
          </div>
        </section>
        {/* END: TRAINING & ENABLEMENT */}

        {/* BEGIN: MENTORSHIP */}
        <section id={sections[1]} ref={sectionRefs?.[sections[1]]}>
          <div className="card rounded-lg">
            <h2 className="heading">{sections[1]}</h2>
            <p>
              <span className="d-block">
                {sectionData[sections[1]].description}
              </span>
            </p>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="trainingBuddyAssisted">
                  {sectionData[sections[1]].questions[0]}
                </label>
                <Answer>{data.trainingBuddyAssisted.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="mentorLeadAssisted">
                  {sectionData[sections[1]].questions[1]}
                </label>
                <Answer>{data.mentorLeadAssisted.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="reviewsTaken">
                  {sectionData[sections[1]].questions[2]}
                </label>
                <Answer>{data.reviewsTaken.answer}</Answer>
              </div>
            </div>
          </div>
        </section>
        {/* END: MENTORSHIP */}

        {/* BEGIN: PROJECTS */}
        <section id={sections[2]} ref={sectionRefs?.[sections[2]]}>
          <div className="card rounded-lg">
            <h2 className="heading">{sections[2]}</h2>
            <p>
              <span className="d-block">
                {sectionData[sections[2]].description}
              </span>
            </p>
            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="jobSkills">
                  {sectionData[sections[2]].questions[0]}
                </label>
                <Answer>{data.projectsUndertaken.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="projects">
                  {sectionData[sections[2]].questions[1]}
                </label>
                <Answer>{data.projects.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="codeReviewsTaken">
                  {sectionData[sections[2]].questions[2]}
                </label>
                <Answer>{data.codeReviewsTaken.answer}</Answer>
              </div>
            </div>

            {/* <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="codeReviewsTakenArchitect">
                  {sectionData[sections[2]].questions[3]}
                </label>
                <Answer>{data.codeReviewsTakenArchitect.answer}</Answer>
              </div>
            </div> */}

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label
                  className="question"
                  htmlFor="architecturalSolutionsDesigned"
                >
                  {sectionData[sections[2]].questions[3]}
                </label>
                <Answer>{data.architecturalSolutionsDesigned.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="achievements">
                  {sectionData[sections[2]].questions[4]}
                </label>
                <Answer>{data.achievements.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="csatScore5Projects">
                  {sectionData[sections[2]].questions[5]}
                </label>
                <Answer>{data.csatScore5Projects.answer}</Answer>
              </div>
            </div>
          </div>
        </section>
        {/* END: PROJECTS */}

        {/* BEGIN: GENERAL */}
        <section id={sections[3]} ref={sectionRefs?.[sections[3]]}>
          <div className="card rounded-lg">
            <h2 className="heading">{sections[3]}</h2>
            <p>
              <span className="d-block">
                {sectionData[sections[3]].description}
              </span>
            </p>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="jobSkills">
                  {sectionData[sections[3]].questions[0]}
                </label>
                <Answer>{data.selfAssessment.jobSkills.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="technicalSkills">
                  {sectionData[sections[3]].questions[1]}
                </label>
                <Answer>{data.selfAssessment.technicalSkills.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="responsiveness">
                  {sectionData[sections[3]].questions[2]}
                </label>
                <Answer>{data.selfAssessment.responsiveness.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="communicationSkills">
                  {sectionData[sections[3]].questions[3]}
                </label>
                <Answer>
                  {data.selfAssessment.communicationSkills.answer}
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="teamwork">
                  {sectionData[sections[3]].questions[4]}
                </label>
                <Answer>{data.selfAssessment.teamwork.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="flexibility">
                  {sectionData[sections[3]].questions[5]}
                </label>
                <Answer>{data.selfAssessment.flexibility.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="inclusiveness">
                  {sectionData[sections[3]].questions[6]}
                </label>
                <Answer>{data.selfAssessment.inclusiveness.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="initiative">
                  {sectionData[sections[3]].questions[7]}
                </label>
                <Answer>{data.selfAssessment.initiative.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="initiativeDetails">
                  {sectionData[sections[3]].questions[8]}
                </label>
                <Answer>{data.initiativeDetails.answer}</Answer>
              </div>
            </div>
          </div>
        </section>
        {/* END: GENERAL */}

        {/* BEGIN: TRAINING REQUIREMENTS */}
        <section id={sections[4]} ref={sectionRefs?.[sections[4]]}>
          <div className="card rounded-lg">
            <h2 className="heading">{sections[4]}</h2>
            <p>
              <span className="d-block">
                {sectionData[sections[4]].description}
              </span>
            </p>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="trainingDevelopmentNeeds">
                  {sectionData[sections[4]].questions[0]}
                </label>
                <Answer>{data.trainingDevelopmentNeeds.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="initiative">
                  {sectionData[sections[4]].questions[1]}
                </label>
                <Answer>{data.additionalInfo.answer}</Answer>
              </div>
            </div>
          </div>
        </section>
        {/* END: TRAINING REQUIREMENTS */}
      </div>
    </div>
  );
};

export default ReadOnlyPerformance;
